import { makeStyles } from '@mui/styles'
import FormatDate from '../../../../../date/FormatDate'
import CustomAvatar from '../../../../../avatar/Avatar'
import { Typography } from '@mui/material'

export const useStyles = makeStyles(() => ({
  customWidthGuttmanChart: {
    minWidth: 300,
    maxWidth: 350,
    padding: '0.5rem'
  },
  customWidthStudentDistribution: {
    maxWidth: `calc(450px + 4rem)`,
    minWidth: 400,
    padding: '0.5rem'
  },
  infoGuttmanChart: {
    borderRadius: '0.25rem',
    overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '0.75rem',
    '&:hover': {
      outlineStyle: 'solid',
      outlineWidth: '1px',
      outlineColor: 'var(--muted-foreground)'
    }
  },
  customWidth: {
    maxWidth: 350,
    minWidth: 200,
    padding: '0.5rem'
  },
  customWidth2: {
    maxWidth: `calc(600px + 4rem)`,
    padding: '0.5rem'
  },
  info: {
    borderRadius: '100%',
    overflow: 'hidden',
    cursor: 'pointer',
    '&:hover': {
      outlineStyle: 'solid',
      outlineWidth: '1px'
      // outlineColor: "var(--muted-foreground)",
    }
  }
}))

const Row = ({ name, value, width = 'min-w-70px max-w-70px' }) => (
  <div className='flex gap-2 items-center py-1'>
    <div className={`font-bold ${width} text-xs text-right uppercase text-elipsis overflow-hidden`}>
      {name}
    </div>
    <div className='w-full text-ellipsis text-sm col-span-2'>{value}</div>
  </div>
)
const RenderCurriculum = ({ element, elementData, value, formValue }) => {
  const find = element?.children?.find((item) => item._id === value)

  return (
    <>
      {Object.keys(formValue || {})
        .reverse()
        .map((key) => {
          const findData = elementData?.children?.find((item) => item._id === key)
          const elementD = find?.elements?.find((item) => item.elementStructureId === key)

          return (
            <RenderCurriculum
              key={key}
              element={elementD}
              elementData={findData}
              formValue={formValue[key].children}
              value={formValue[key].value}
            />
          )
        })}
      <Row key={element._id} name={elementData.name} value={find.name} />
    </>
  )
}

export const ContentTooltiptLearningContinuumInfo = ({ currentCurriculum, lc }) => {
  return (
    <>
      {currentCurriculum?.lcElements?.children
        ?.sort((a, b) => b.position - a.position)
        ?.map((item) => {
          const itemData = lc?.lcElements ? lc?.lcElements[item._id] || '' : ''
          return <Row key={item._id} name={item.name} value={itemData} />
        })}
      {/* {Object.keys(lc?.curriculumElements || {}).map((key) => {
        return (
          <RenderCurriculum
            key={key}
            element={currentCurriculum?.elements}
            elementData={currentCurriculum?.elementsStructure}
            formValue={lc?.curriculumElements[key].children}
            value={lc?.curriculumElements[key].value}
          />
        );
      })} */}
    </>
  )
}

export const ContentTooltiptLevelInfo = ({ level }) => {
  return (
    <>
      <Row name='Level' value={level.name} />
      <Row name='Definition' value={level.definition} />
    </>
  )
}

export const ContentTooltipMarkingInfo = ({ marking, width = 'min-w-70px max-w-70px' }) => {
  return (
    <>
      <Row
        width={width}
        name={
          <div className='flex justify-end'>
            <div
              style={{
                height: 15,
                width: 15,
                backgroundColor: marking?.markingPrimaryColor
              }}
              className={['rounded', marking?.markingPrimaryColor ? '' : ' bg-lines '].join(' ')}
            />
          </div>
        }
        value={marking?.markingName || marking?.markingTitle}
      />
      {marking.markingType && marking.markingType.replace('completed', '') !== 'completed' && (
        <Row name='Type' value={marking.markingType.replace('completed', '')} />
      )}
      {!marking?.markingDate ? (
        <></>
      ) : (
        <>
          <Row
            name='Date'
            width={width}
            value={marking?.markingDate === 'None' ? 'None' : <FormatDate date={marking?.markingDate} />}
          />
          {marking?.markingClosedBy ? (
            <Row width={width} name='closed by' value={marking?.markingClosedBy} />
          ) : (
            <Row width={width} name='Marking by' value={marking?.markingBy} />
          )}
        </>
      )}
      {marking?.markingClosedBy && <Row width={width} name='Marking by' value={marking?.markingBy} />}
    </>
  )
}

export const ContentTooltipStudentInfo = ({ student = {}, justify = 'center', className }) => {
  return (
    <div className={`flex gap-2 justify-${justify} items-center py-2 text-sm  ${className}`}>
      <CustomAvatar alt={student.code} src={`photos/${student.photo}`} size={'xsmall'} />
      <div className='overflow-hidden'>
        <p className='font-bold text-xs'>{student.code}</p>
        <p className='text-ellipsis text-sm text-nowrap'>{student.fullName}</p>
      </div>
    </div>
  )
}

export const ContentTooltiptStudentMarkingInfo = ({ student, marking, width }) => {
  return (
    <>
      <ContentTooltipStudentInfo width={width} student={student} />
      <div className='border-t border-muted my-1' />
      <ContentTooltipMarkingInfo width={width} marking={marking} />
    </>
  )
}

export const ContentTooltiptStudentLevelMarkingInfo = ({ student, marking, width, level }) => {
  return (
    <>
      <ContentTooltipStudentInfo width={width} student={student} />
      <div className='border-t border-muted my-1' />
      <ContentTooltiptLevelInfo level={level} />
      <div className='border-t border-muted my-1' />
      <ContentTooltipMarkingInfo width={width} marking={marking} />
    </>
  )
}

export const ContentTooltiptLearningContinuumLevelMarkingInfo = ({
  currentCurriculum = {},
  lc,
  level,
  marking
}) => {
  return (
    <div>
      <ContentTooltiptLearningContinuumInfo currentCurriculum={currentCurriculum} lc={lc} />
      <div className='border-t border-muted my-2' />
      <ContentTooltiptLevelInfo level={level} />
      <div className='border-t border-muted my-2' />
      <ContentTooltipMarkingInfo marking={marking} />
      <div className='my-1' />
    </div>
  )
}

export const ContentTooltiptStudentDistribution = ({
  students = [],
  marking,
  width,
  level,
  percentage,
  onClick
}) => {
  return (
    <>
      <Typography className='font-bold text-lg text-center'>{percentage}</Typography>
      <ContentTooltipMarkingInfo width={width} marking={marking} />
      <ContentTooltiptLevelInfo level={level} />
      <div className='border-t border-muted my-1' />
      <Typography className='font-bold text-xs text-center'>Students ({students.length})</Typography>
      <div className='border-t border-muted my-1' />
      <div className='grid grid-cols-5 gap-2'>
        {students.map((student, index) => (
          <div
            key={`student-distribution-${student.studentId}-index-${index}`}
            className='flex flex-wrap gap-2 justify-start items-center overflow-hidden bg-clickeabled2 cursor-pointer'
            onClick={() => onClick(student)}
          >
            <div className={'bg-loading rounded min-w-100px max-w-100px py-1 '}>
              <ContentTooltipStudentInfo width={width} student={student} justify='start' className=' px-2 ' />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export const ContentTooltiptStudentDistribution2 = ({
  students = 0,
  totalStudents = 0,
  marking,
  width,
  level,
  percentage,
  onClick
}) => {
  return (
    <>
      <Typography className='font-bold text-lg text-center'>{percentage}</Typography>
      <ContentTooltipMarkingInfo width={width} marking={marking} />
      <ContentTooltiptLevelInfo level={level} />
      <div className='border-t border-muted my-1' />
      <Typography className='font-bold text-xs text-center'>
        Students ({students} / {totalStudents})
      </Typography>
      {/* <div className='border-t border-muted my-1' />
      <div className='grid grid-cols-5 gap-2'>
        {students.map((student, index) => (
          <div
            key={`student-distribution-${student.studentId}-index-${index}`}
            className='flex flex-wrap gap-2 justify-start items-center overflow-hidden bg-clickeabled2 cursor-pointer'
            onClick={() => onClick(student)}
          >
            <div className={'bg-loading rounded min-w-100px max-w-100px py-1 '}>
              <ContentTooltipStudentInfo width={width} student={student} justify='start' className=' px-2 ' />
            </div>
          </div>
        ))}
      </div> */}
    </>
  )
}

export const ContentTooltiptAnalyticsCurriculum = ({ lc, currentCurriculum }) => {
  return <ContentTooltiptLearningContinuumInfo currentCurriculum={currentCurriculum} lc={lc} />
}
